/*
 * @Author: xiaolong.xu
 * @Date: 2023-08-10 14:07:09
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-09-07 16:04:39
 * @Description: 判断是否为灰度用户，是的话就开启会员模式，目前会员升级升级和消费功能仅针对外部个人用户开启，在这个做统一的控制
 */
import React, { useMemo } from 'react'
import globalStore from '@/globalStore'
import { observer, useLocalObservable } from 'mobx-react-lite'

interface Props {
  children: React.ReactElement
  placeholder?: any
}

const MemberGrayscalePermissions = (props: Props) => {
  const globalMobx = useLocalObservable(() => globalStore)
  const { children, placeholder = null } = props
  const isMemberGray = useMemo(() => {
    if (globalMobx?.userInfo?.isBindSSO) {
      return false
    }
    if (globalMobx?.userInfo?.corporationId) {
      return false
    }
    return true
  }, [globalMobx?.userInfo, globalMobx?.userInfo?.corporationId])

  return isMemberGray ? children : placeholder
}

// 判断是否是会员灰度用户
export const isMemberGrayscalePermissions = () => {
  if (globalStore?.userInfo?.isBindSSO) {
    return false
  }
  if (globalStore?.userInfo?.corporationId) {
    return false
  }
  return true
}

// 是否普通会员身份
export const isGrayOrdinaryMembers = () => {
  const userInfo = globalStore?.userInfo
  return (
    !userInfo?.isBindSSO &&
    userInfo.corporationId === null &&
    (!userInfo.memberLevel ||
      (userInfo.memberLevel === 1 && userInfo.memberStatus === 2) ||
      (userInfo.memberLevel === 2 && userInfo.memberStatus === 2))
  )
}

// 是否为试用会员
export const isGrayProbationaryMembers = () => {
  const userInfo = globalStore?.userInfo
  return (
    !userInfo?.isBindSSO &&
    userInfo.corporationId === null &&
    userInfo.memberLevel === 2 &&
    userInfo.memberStatus === 1
  )
}

// 是否允许领取试用期会员
// 试用期会员领取条件：从未购买过会员的用户（按会员购买记录判断，不限制活动上线时间以后）
export const isAllowGrayProbationaryMembers = () => {
  const userInfo = globalStore?.userInfo
  return (
    !userInfo?.isBindSSO &&
    userInfo.corporationId === null &&
    !userInfo.memberLevel &&
    userInfo.memberLevel !== 1
  )
}

export default observer(MemberGrayscalePermissions)
